export const BUILDING_CLASSES_OPTIONS = ['Trophy', 'A', 'B', 'C'];
